import styled from 'styled-components';

const UploadedEmailModal = styled.div`
  position: relative;
  width: 100%;
`;

const Row = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
`;

const Col = styled.div`
  align-items: center;
  display: flex;
`;

export { Col, Row, UploadedEmailModal };
